export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15138.a22936b6.jpg";